module.exports = __webpack_public_path__ + "img/left_image_big_screen.52d5563e.png";